import { Component, OnInit } from '@angular/core';
import { SurveyService } from '../services/survey.service';
import { UsageReport } from '../models/usage-report.model';

@Component({
  selector: 'app-usage-report',
  templateUrl: './usage-report.component.html',
  styleUrls: ['./usage-report.component.css']
})
export class UsageReportComponent implements OnInit {
  usageData: UsageReport[];

  constructor(private surveyService: SurveyService) { }

  ngOnInit() {
    this.surveyService.getUsageReport().subscribe(responseData=>{
      this.usageData = responseData;
    })
  }

}
